export { default } from "./DeletePlayerDialogContainer";
